<template>
    <div><!-- JQM 上傳 -->
        <CCard class="w-100">
            <CCardHeader>
                <strong>JQM</strong>
            </CCardHeader>
            <CCardBody>
                    <CForm>
                        <div class="CForminline">
                            <div class="fluid">
                                <div class="search-fluid">
                                    <p>&emsp;&emsp;{{$t('QuoteInfo_Vue.FactoryType')}}：</p>
                                    <div v-for="(item, key) in factoryList" :key="'factoryType_input_' + key">
                                       <input :disabled ="disableFactory" type="radio" :name="'jqm_FactoryTypeOpt'" v-model="jqmUploadQueryParam.factoryId" :value="item.factoryId" >{{getFactoryCaption(item.factoryId,item.factoryCaption)}}
                                    </div> 
                                </div>
                            </div>
                            <div class="fluid">                               
                                <div class="search-fluid">
                                    <p>{{ i18n('JQM.VendorName') }}：</p>                                    
                                    <input style="width: 300px;" type="text" v-if="disableCusName_input" :disabled="true" v-model="jqmUploadQueryParam.customerName">                                                        
                                    <Select2 style="width: 300px;" v-if="!disableCusName_input" v-model="jqmUploadQueryParam.vendorId" :options="memberListFilter()" :settings="{  multiple: false, dropdownAutoWidth : true , width: '100%' ,allowClear:true}" />
                                </div>
                                <div class="search-fluid">
                                    <p>{{ i18n('JQM.YearAndMonthAssigned') }}：</p>
                                    <input type="text" style="width:300px;" maxlength="10" v-model="jqmUploadQueryParam.yearMonth">
                                </div>
                            </div>                            
                            <div class="fluid">
                                <div class="search-fluid">
                                    <p>&emsp;{{ i18n('JQM.GroupClassificationCode') }}：</p>
                                    <input type="text" style="width:300px;" maxlength="50" v-model="jqmUploadQueryParam.jqmDtlNum">
                                </div>
                                <div class="search-fluid">
                                    <p>&emsp;{{ i18n('JQM.WeekAssigned') }}：</p>
                                    <input type="text"  style="width:300px;" maxlength="10" v-model="jqmUploadQueryParam.jqmWeek">
                                </div>
                            </div>
                            
                            <div class="fluid">
                                <div class="search-fluid">
                                    <p>&emsp;&emsp;{{$t('QualityInfo_Vue.Status')}}：</p>
                                    <div v-for="(item, key) in rowStatusList" :key="'jqmRowStatus_input_' + key">
                                       <input type="radio" :name="'jqm_RowStatusOpt'" v-model="jqmUploadQueryParam.rowStatus" :value="item.rowStatusId" >{{item.rowStatusCaption}}
                                    </div> 
                                </div>
                            </div>

                            <div class="fluid">
                                <div class="search-fluid">
                                    <p>{{$t('JQM.EstablishedDates')}}：</p>
                                    <date-picker :lang="lang" format="YYYY-MM-DD" valueType="format" v-model="jqmUploadQueryParam.createDateBegin"></date-picker> 
                                    <span>~</span>
                                    <date-picker :lang="lang" format="YYYY-MM-DD" valueType="format" v-model="jqmUploadQueryParam.createDateEnd"></date-picker>
                                </div>
                            </div>

                            <div class="btn_group">                                
                                <button type="button" class="btn btn-edit mr-2" @click="jqmUploadQueryEvent">{{$t('Buttons.Query')}}</button>
                                <button type="button" class="btn btn-success mr-2" @click="jqmUploadExportEvent">{{$t('Buttons.ExportOrder')}}</button>
                                <router-link class="btn btn-primary" v-if="isMember"  to="" @click.native="jqmUploadAddNewEvent">{{$t('Buttons.AddNew')}}</router-link>
                            </div>                            
                        </div>
                    </CForm>
            </CCardBody>
        </CCard>

        <CCard>
            <CCardBody>
                <table class="table ">
                    <thead class="thead-light">
                        <tr>
                            <th class="text-center">{{headers[0]}}</th>
                            <th class="text-center">{{headers[1]}}</th>
                            <th class="text-center">{{headers[2]}}</th>
                            <th class="text-center">{{headers[3]}}</th>
                            <th class="text-center">{{headers[4]}}</th>
                            <th class="text-center">{{headers[5]}}</th>
                            <th class="text-center">{{headers[6]}}</th>
                            <th class="text-center">{{headers[7]}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item , index) in jqmUploadSearchResult" :key="index">
                            <td class="text-center">{{fixDateTime(item.jqmCreateDate)}}</td>
                            <td class="text-center">{{fixDateTime(item.jqmUpdateDate)}}</td>
                            <td class="text-center">{{item.customerName}}</td>
                            <td class="text-center" v-c-tooltip="$toolTip(item.allJqmDtlName)">{{item.allJqmDtlName}}</td>
                            <td class="text-center">{{item.jqmYearmonth}}</td>
                            <td class="text-center">{{item.jqmWeek}}</td>
                            <td class="text-center">{{item.jqmStatusTxt}}</td>
                            <td class="text-center">
                                <button class="btn btn-sm btn-danger" @click="deleteRowEvent(item)" v-if="isShowDelBtn(item)">{{i18n('Buttons.Delete')}}</button>
                                <router-link class="btn btn-sm btn-success"  @click.native="editRowEvent(item)" to="">{{editBtnText(item)}}</router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </CCardBody>
        </CCard>
        <!-- <Modal /> -->
    </div>
</template>
<script>
import { qualityMixin } from '@/mixin/quality'
import { mapGetters } from 'vuex'
export default {
    mixins: [qualityMixin],	
    data() {
        return {
            headers :[
                this.i18n("JQM.EstablishedDate"),this.i18n("JQM.InputTime"),this.i18n("JQM.Vendor"),this.i18n("JQM.GroupClassificationCodeChinese"),
                this.i18n("JQM.YearAndMonthAssigned"),this.i18n("JQM.WeekAssigned"),this.i18n("JQM.Status"),this.i18n("JQM.Function")
            ],
            factoryList: this.$t('factoryQMList'), //廠別 清單
            rowStatusList: this.$t('rowStatusList'), //狀態 清單
            jqmUploadQueryParam: {
                hadQuery : false,
                factoryId : '',
                customerName : '',
                createDateBegin :null,
                createDateEnd :null,
                yearMonth : '', //歸屬年月
                jqmDtlNum : '', //分群碼
                jqmWeek : '', //歸屬週
                rowStatus : ''
            },
            jqmUploadSearchResult:[]
        }
    },
    props : {
    },
    watch: {
        "lang":function() {
            this.factoryList = this.$t('factoryQMList') //廠別 清單
            this.rowStatusList = this.$t('rowStatusList') //狀態 清單

            this.headers = [
                this.i18n("JQM.EstablishedDate"),this.i18n("JQM.InputTime"),this.i18n("JQM.Vendor"),this.i18n("JQM.GroupClassificationCodeChinese"),
                this.i18n("JQM.YearAndMonthAssigned"),this.i18n("JQM.WeekAssigned"),this.i18n("JQM.Status"),this.i18n("JQM.Function")
            ]
        }
    },
    methods: {
        jqmUploadQueryEvent (){
            this.jqmUploadQueryParam.hadQuery = true;
            this.doJqmUploadSearch (this.jqmUploadQueryParam);         
        },
        doJqmUploadSearch (param){
            const url = `${this.$apiUrl_Quality}/SearchJqmUpload`;
            this.updateLoading(true);
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功
                    const rowStatusMap= this.listToMap(this.$t('rowStatusList'), 'rowStatusId' ,'rowStatusCaption');
                    const rows = response.data;                    
                    rows.forEach(r => {
                        let rowStatusTxt = '';
                        let rowStatus = '';
                        if(r.jqmStatus === 0){
                            rowStatus ='A';
                        }else if(r.jqmStatus === 1){
                            rowStatus ='B';
                        }else if(r.jqmStatus === 2){
                            rowStatus ='C';
                        }
                        if(rowStatus){
                            rowStatusTxt = rowStatusMap[rowStatus];
                        }                        
                        r.jqmStatusTxt = rowStatusTxt;
                    });
                    this.jqmUploadSearchResult = rows;
                    this.setCacheQueryParam('JqmUpload_QueryParam' , param);                           
                }                    
            }); 
        },        
        jqmUploadExportEvent (){//匯出
            this.doJqmUploadExport(this.jqmUploadQueryParam)
        },
        doJqmUploadExport(param){
            const url = `${this.$apiUrl_Quality}/PrepareSearchJqmUploadExport`;
            this.axios.post(url, param).then((response) => {                        
                const respObj = response.data;                 
                const exportExcelToken = respObj.token;
                let urlExcel = `${this.$apiUrl_Quality}/SearchJqmUploadExportExcel/${exportExcelToken}`;
                this.openNewTabByALink('JqmUploadExportExcel',urlExcel);
            })
        },
        jqmUploadAddNewEvent (){
            sessionStorage.setItem('jqmGuid', 'new');       
            this.$router.push('jqminformation');
        },
        isShowDelBtn (item){
            if(item.jqmStatus === 2){//退件，才可有刪除
                if(this.isMember){
                    return true;
                }
            } 
            return false;
        },
        editBtnText (item){                  
            if(item.jqmStatus === 0){
                if(!this.isMember){
                    return this.i18n("Buttons.Maintain");
                }                
            }else if(item.jqmStatus === 2){
                return this.i18n("Buttons.Maintain");
            }
            return this.i18n("Buttons.DetailInfo");
        },
        deleteRowEvent (item){ //刪除
            const self =this;
            this.$confirm('此操作將永久刪除該筆資料, 是否繼續?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                self.doDeleteRow(item.jqmGuid);
            });
        },
        doDeleteRow (jqmGuid){//呼叫刪除處理
            const url = `${this.$apiUrl_Quality}/DeleteJQMUploadRow`;
            this.updateLoading(true);
            const param = { guid: jqmGuid};
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功
                    this.doJqmUploadSearch (this.jqmUploadQueryParam);
                }                    
            }); 
        },
        editRowEvent (item){ //維護 / 詳細資訊            
            sessionStorage.setItem('jqmGuid', item.jqmGuid);
            this.$router.push('jqminformation');
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
    },
    computed: {
        ...mapGetters(["lang"])
    },
	mounted() {
        this.getCacheQueryParam('JqmUpload_QueryParam' , this.jqmUploadQueryParam);        
        const userFactoryId= this.userFactoryId;
        if(userFactoryId){
            //this.jqmUploadQueryParam.factoryId = userFactoryId;
        }
        if(this.isMember){
            const userInfo = this.$userInfo ;
            this.jqmUploadQueryParam.vendorId = userInfo.vendorId;
            this.jqmUploadQueryParam.customerName = userInfo.companyName;
        }else{
            this.initMemberQMList();
        }
        if(this.jqmUploadQueryParam.hadQuery){
            this.jqmUploadQueryEvent();
        }
	},
    created() {        
    }
}
</script>

<style lang="scss" scoped>
.CForminline {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    > .form-group {
        margin-bottom: 0;
    }

    > .fluid {
        display: flex;
        align-items: center;

        > .search-fluid {
            display: flex;
            align-items: center;
            margin: .5rem 1rem;
            margin-left: 0;
            // width: 500px;

            > p {
                margin-right: 1rem;
                margin-bottom: 0;
            }
            > .purchase_input {
                margin-bottom: 0;
            }
            > input {
                flex: 1;
                margin: 0 .5rem;
            }
            > div {
                margin: 0 .5rem;
            }
        }
    }
}

.btn-edit {
    background-color: #343b55;
    color: white;
}

table th:first-child {
    text-align: center;
    padding: 15px 5px;
}

.table tr:nth-child(even) {
    background-color: transparent;
}

.table th {
    background-color: #303c50;
    color: #fff;
}
.table td{
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>

